import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert,  Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'

import svgWait2 from './svg/wait2.gif'


import { departmentINFO,  sbConfig } from './Types'
import { SystemHeader } from './CommonUI';

import { transpileModule } from 'typescript';
import { stringify } from 'querystring';


interface PageInfo {
    n: number
}

var GsbFlag: any;

interface CCassAddDeptViewProps {
    gsb: AxiosInstance,
    departmentINFO: departmentINFO,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}



function CCassAddDeptView({ gsb, departmentINFO = {} as departmentINFO, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: CCassAddDeptViewProps) {

    const [isDeletePress, setisDeletePress] = useState(false)

     const [CHQ_NAME, setCHQ_NAME] = useState(false)
     const [SUSPEND_AC, setSUSPEND_AC] = useState(false)
     const [CM2K_USER, setCM2K_USER] = useState(false)
     const [GSBx_USER, setGSBx_USER] = useState(false)

  //   const [def_d_CCOMMOPT,setdef_d_CCOMMOPT] = useState(CCRConfig.d_CCOMMOPT)
    // const [def_d_CCOMDIR,setdef_d_CCOMDIR] =useState(CCRConfig.d_CCOMDIR)
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                setSUSPEND_AC(GsbFlag.SUSPEND_AC)               
                setCHQ_NAME(GsbFlag.CHQ_NAME)
                setCM2K_USER( GsbFlag.CM2K_USER);
                //console.log("set StatusList: ", StatusList)
 
                setGSBx_USER(GsbFlag.GSBx_USER) ;
               
                //console.log(CCRConfig)
                
            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, departmentINFO ])



   // if (! ("DepartmentID" in departmentINFO)) return null


    return (
        <div>
            <div className="Row">
                {/*<Button className="Col-1-1" disabled={true} icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>*/}
                <Button className="Col-1-1" disabled={false} icon="add" onClick={() => onNew()} >New</Button>
                {/*<Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>*/}
                {/*<Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>*/}
                {/*<Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                <Button className="Col-5-1" disabled={true} icon="direction-right" onClick={() => onNextRec()} >Next</Button>*/}
                
            </div>
            <div className="Spacing-V-16" />
 
 


            <div className="Spacing-V-16" />

           
        </div>
    )
}

interface CCassAddDeptEditProps {
    gsb: AxiosInstance,
    departmentINFO?: departmentINFO,
    isNew?: boolean,
    onSave?: (department: departmentINFO) => void,
    onCancel?: () => void;
}

// onChange={utils.handleStringChange(s => setAc(prevState => Object.assign(prevState, {acName1: s})))}
function CCassAddDeptEdit({ gsb, departmentINFO = {} as departmentINFO, isNew = false, onSave = () => { }, onCancel = () => { } }: CCassAddDeptEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<departmentINFO>()
    const [CHQ_NAME, setCHQ_NAME] = useState(false)    
    const [SUSPEND_AC, setSUSPEND_AC] = useState(false)  
    const [CM2K_USER, setCM2K_USER] = useState(false)
    const [GSBx_USER, setGSBx_USER] = useState(false) 
    //const [def_d_OwnPartID, setdd_OwnPartID] = useState(CCRConfig.d_OwnPartID)
 

    const [def_DepartmentID,setdef_DepartmentID] = useState(departmentINFO.DepartmentID)
    const [def_DepartmentName,setdef_DepartmentName] = useState(departmentINFO.DepartmentName)
 
    useEffect(() => {
        // Call reset to set default values if ac is passed

       
        
        if ("DepartmentID" in departmentINFO) {
            reset(departmentINFO)
        }
    }, [departmentINFO, reset])

    
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                setSUSPEND_AC(GsbFlag.SUSPEND_AC) ;              
                setCHQ_NAME(GsbFlag.CHQ_NAME);
                //console.log("set StatusList: ", StatusList)
                setCM2K_USER( GsbFlag.CM2K_USER);
                setGSBx_USER(GsbFlag.GSBx_USER) ;

            } catch (error) {
                //utils.showError(error)
            }
        })()
    }, [gsb, departmentINFO])


    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        //register({ name: "d_status" })
    }, [register])

    
    useEffect(() => {

         if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
    

   // if (! isNew && !("DepartmentName" in DepartmentName)) return null


    const onSubmit = (data: departmentINFO) => {
        //console.log("onsubmit called", data)

      
       data.DepartmentID =def_DepartmentID ;
       data.DepartmentName = def_DepartmentName;

        (async () => {
            try {
                //console.log("call CCRConfigEdit data", data)
                //console.log("call CCRConfigEdit isNew", isNew)  CCSettingValidate
                const res = await gsb.post('/Report', {sb_data: data, cPgmId: "CCASSMast", cAction: "CCSettingValidate", isNew: isNew})
                //console.log("CCRConfigEdit res.data.ok", res.data.ok)
                //console.log("CCRConfigEdit res.data.data", res.data.data)
                
               
                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    return
                }
                

                onSave(data)
               
            } catch (error) {
                showErrorBox(error)
            }
        })()
    }

    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }
    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ac)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
           <div className="Row">
                <FormGroup className="Col-1-2" label="Department name">                  
                </FormGroup>
                <FormGroup className="Col-3-2">   
                    <InputGroup name ="DepartmentName" id="DepartmentName" defaultValue={def_DepartmentName}   onChange={utils.handleStringChange(n => setdef_DepartmentName(n))} inputRef={register}/>                      
                    {errors.DepartmentName && errors.DepartmentName.types && <span id="Err_msg">{errors.DepartmentName.types.message}</span>}
                </FormGroup>                      
 
            </div>
            
            <div className="Spacing-V-16"></div>
            {/*<br></br>*/}
            {/*<p>Notes</p>*/}
    
        </form>
    )
}

interface CCassAddDeptMainProps {
    gsb: AxiosInstance 
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function CCassAddDeptMain({ gsb}: CCassAddDeptMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [data, setData] = useState([] as departmentINFO[])


    const [searchKey, setSearchKey] = useState("OpenDate")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)
    const [showButton, setshowButton] = useState(false)


    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("Detail")
    const [currentAc, setCurrentAc] = useState({} as departmentINFO)
    const [BlankAc, setBlankAc] = useState({} as departmentINFO)
    const [sbConfigRec, setsbConfigRec] = useState({} as sbConfig)

    const [currentMode, setCurrentMode] = useState("show")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    

    
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    //gsb default value
    //BlankAc.d_p_Pref = "P"
   
     const [departmentInfoList,setdepartmentInfoList] = useState ([] as departmentINFO[])
     const [s_DepartmentName,sets_DepartmentName] = useState("Default")
     

    useEffect(() => {
        (async () => {
            try {

             
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
 
                GsbFlag = res.data.Flag;
 
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;

                if ( GsbFlag.isProduction == "Y" ) {
    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
} else {
    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
}
                //console.log("set StatusList: ", StatusList)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, currentMode])


    useEffect(() => {
        //console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, GsbFlag, cardOpen01])


    useEffect(() => {
        //processListCCASSRptName in -> 
        (async () => {
            try {
                const res = await gsb.post('/Report',
                    {   sb_data: {                           
                           
                        },
                        cPgmId: "CCASSMast",
                        cAction: "ListDepartment",
                    });
                setdepartmentInfoList(res.data.data)
                console.log("setdepartmentInfoList: ", res.data.data)
               
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


 

    const PrevRecProcess = async (department: departmentINFO) => {
/*        
        try {
            //console.log("call PrevRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "department", cAction: "PrevRec"})
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const DeleteProcess = async (department: departmentINFO) => {
/*        
        try {
            //console.log("call DeleteProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "department", cAction: "DelRec"})
            showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

    const NextRecProcess = async (department: departmentINFO) => {
/*        
        try {
            //console.log("call NextRecProcess", ac)
            const res = await gsb.post('/Master', {sb_data: ac, cPgmId: "department", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/        
    }

  
 
    const newOnSave = async (department: departmentINFO) => {
       //DataFormat
        try {
            const res = await gsb.post('/Report', {sb_data: department, cPgmId: "CCASSMast", cAction: "AddRec"})
             showSuccess("Department Setting  ccass_" + department.DepartmentName + ".csv"+  " is added, Please reload Browser!!")

            for (let i = 0; i < data.length; i++) {
                if (data[i].DepartmentName === res.data.data.DepartmentName) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
         
        }
    }

    const editOnSave = async (department: departmentINFO) => {
/*        
        try {
            console.log("call editOnSave", department)
            const res = await gsb.post('/Master', {sb_data: department, cPgmId: "CCASSMast", cAction: "UpdateRec"})
 
            showSuccess("CCR Configuration Record Saved")
            setCurrentAc(res.data.data[0])
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
*/            
    }
 
    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }
    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            //handleSubmit(onSubmit)()
        }
    }

    
    const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
        if (event.key === 'Enter') {
        event.preventDefault(); // Prevents default Enter key behavior (form submission)
        }
    };


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

        const DepartmentListRenderer: ItemRenderer<departmentINFO> = (setdepartmentInfoList, { handleClick, modifiers, query }) => {
            if (!modifiers.matchesPredicate) {
                return null;
            }
            //const text = `${ac.acCode} - ${ac.acName1}`;
            const text = `${setdepartmentInfoList.DepartmentName}`;
            return (
                <MenuItem
                    active={modifiers.active}
                    disabled={modifiers.disabled}
                    //label={setdepartmentInfoList.DepartmentID}
                    key={setdepartmentInfoList.DepartmentName}
                    onClick={handleClick}
                    text={highlightText(text, query)}
                />
            );
        };
    
        const DepartmenListPredicate: ItemPredicate<departmentINFO> = (query, departmentInfoList, _index, exactMatch) => {
            const normalizedText = "" //`${departmentInfoList.DepartmentName}`.toLowerCase();
            
            const normalizedQuery = query.toLowerCase();
    
            if (exactMatch) {
                return normalizedText === normalizedQuery;
            } else {
                return normalizedText.indexOf(normalizedQuery) >= 0;
            }
        };
    
        const DepartmenListValueRenderer = (departmentInfoList: departmentINFO) => {
            return departmentInfoList.DepartmentName
        }
        
    

    // currentMode = show
    let detail = <CCassAddDeptView gsb={gsb} departmentINFO={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></CCassAddDeptView>
    switch (currentMode) {
        case "edit":
            detail = <CCassAddDeptEdit gsb={gsb} departmentINFO={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></CCassAddDeptEdit>
           break
        case "new":
            detail = <CCassAddDeptEdit gsb={gsb} departmentINFO={BlankAc} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></CCassAddDeptEdit>
            break
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let list = <>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    
    
    return (
        <>
            <form >
                {/*<div className="Spacing-V-Menu"></div>*/}
                {/*<div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>*/}
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Add Department for loading in CCASS Report</H3>
                    {/*
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                    */}

                    {detail}
                </Card>
            </form>
        </>
    );
}

export default CCassAddDeptMain